export default __webpack_public_path__ + "static/media/jm.956c3368.jpg";